import skynityLogo from 'assets/svg/skynity-logo.svg';
import React, { useEffect, useState } from 'react';

export const Preloader: React.FC<{ transparent?: boolean }> = ({
  transparent,
}) => {
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMessage(true);
    }, 3000);

    return () => clearTimeout(timer); // cleanup on unmount
  }, []);

  return (
    <div className={`preloader${transparent ? ' transparent' : ''}`}>
      <div className="preloader-container">
        <div className="preloader-image">
          <img src={skynityLogo} alt="Skynity loader" />
          {showMessage && (
            <div
              className={`preloader-message ${showMessage ? 'visible' : ''}`}
            >
              <div>In case of connection issues while using metamask,</div>
              <div>try removing and adding again your base network...</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Preloader;
